module.exports = __webpack_public_path__ + "static/media/authgent-card.7db2eea1.png";